import { eventTracker } from '@hakimo-ui/hakimo/util';
import { Button } from '@hakimo-ui/shared/ui-base';
import { FunnelIcon } from '@heroicons/react/24/outline';

interface Props {
  isLoading: boolean;
  hasCustomFiltersApplied: boolean;
  onClickFilter: () => void;
}

export function TableHeader(props: Props) {
  const { isLoading, hasCustomFiltersApplied, onClickFilter } = props;

  return (
    <div className="dark:bg-dark-bg flex items-center justify-end border-b bg-white p-4 dark:border-0">
      <Button
        variant="icon"
        badge={hasCustomFiltersApplied}
        onClick={onClickFilter}
        disabled={isLoading}
        onSideEffect={eventTracker('open_audio_devices_filters_panel')}
      >
        <span className="sr-only">Open filters panel</span>
        <FunnelIcon className="h-5 w-5" aria-hidden="true" />
      </Button>
    </div>
  );
}
